import { HeaderPageMessage, LoadingCard } from 'components';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col } from 'antd';
import './EdicionPlantillas.scss';
import { getPlantillas } from 'actions/templates.actions';
import { selectTemplatesState } from 'selectors/templates.selector';
import TemplateItem from './components/TemplateItem';

const EdicionPlantillas = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPlantillas());
  }, []);

  const { loading, data } = useSelector(selectTemplatesState);

  const generateComponents = (listaPlantillas) => {
    return listaPlantillas.map((plantilla) => (
      <TemplateItem plantilla={plantilla} title="Plantilla" key={plantilla.idPlantilla} />
    ));
  };

  return (
    <div className="edicion-plantillas">
      <div className="header-page">
        <Col span={18}>
          <HeaderPageMessage
            title="Edición de plantillas"
            section="Gestión de contenido"
            message="Al guardar los cambios, no se recuperará la versión anterior"
            header="Selecciona la plantilla que deseas modificar."
          />
        </Col>
      </div>

      <div className="contenedor-plantillas">
        <div className="contenedor-centrado">
          <LoadingCard visible={loading} key="loading-edicion-plantillas" />
          {generateComponents(data)}
        </div>
      </div>
    </div>
  );
};

export default EdicionPlantillas;
